/* Core-on-demand: loaded only when snippets/shade-select.liquid renders a scrolling shade CTA. */
import { startShadeScroll } from '@/scripts/optional/shade-scroll'

startShadeScroll()
